import api from "../api/api";
import IFavorite, { FavoriteTargetType, IFavoritePropertyDetails } from "../interfaces/IFavorite";
import IProperty from "../interfaces/IProperty";

export default class FavoriteApiService {
    async createFavorite(targetId: number, targetType: FavoriteTargetType): Promise<IFavorite> {
        const response = await api.put("/user/favorite", {
            dealId: targetType === FavoriteTargetType.Deal ? targetId : null,
            leadId: targetType === FavoriteTargetType.Lead ? targetId : null,
            leaseCompId: targetType === FavoriteTargetType.LeaseComp ? targetId : null,
            propertyDetailsId: targetType === FavoriteTargetType.Property ? targetId : null,
            saleCompId: targetType === FavoriteTargetType.SaleComp ? targetId : null,
            timId: targetType === FavoriteTargetType.TenantInMarket ? targetId : null,
            pipedriveCompanyId: targetType === FavoriteTargetType.Company ? targetId : null,
        });

        return {
            id: response.data.id,
            targetId: targetId,
            targetType: targetType,
            createdAt: new Date(response.data.createdAt),
        };
    }

    async getFavorites(): Promise<IFavorite[]> {
        const response = await api.get("/user/data");
        const favorites = response.data.favorites;

        const targetTypes = {
            dealId: FavoriteTargetType.Deal,
            leadId: FavoriteTargetType.Lead,
            leaseCompId: FavoriteTargetType.LeaseComp,
            propertyDetailsId: FavoriteTargetType.Property,
            saleCompId: FavoriteTargetType.SaleComp,
            timId: FavoriteTargetType.TenantInMarket,
            pipedriveCompanyId: FavoriteTargetType.Company,
        };

        return favorites.map((f: any): IFavorite | undefined => {
            const nonNullIdKey = Object.keys(targetTypes).find(key => f[key] !== null);

            if (nonNullIdKey) {
                return {
                    id: f.id,
                    targetId: f[nonNullIdKey as keyof typeof f],
                    targetType: targetTypes[nonNullIdKey as keyof typeof targetTypes],
                    createdAt: new Date(f.createdAt),
                };
            }
        }).filter(Boolean);
    }

    async deleteFavorite(id: number) {
        await api.delete(`/user/favorite/${id}`);
    }

    async createFavoritePropertyDetails(property: IProperty): Promise<IFavoritePropertyDetails> {
        const propertyDetails = {
            centerPoint: property.centerPoint,
            shapes: [property.shapes[property.parcelIds.findIndex(id => id === property.baseParcelId)]],
            address: property.address,
            state: property.state,
            zip: property.zip,
            city: property.city,
            notesJson: null,
        };

        const response = await api.post("/propertiesdetails/create", propertyDetails);

        return {
            id: response.data,
            ...propertyDetails,
        };
    }

    async getFavoritePropertiesDetails(): Promise<IFavoritePropertyDetails[]> {
        const response = await api.get("/propertiesdetails");
        return response.data;
    }

    async deleteFavoritePropertyDetails(id: number) {
        await api.delete(`/propertiesdetails/${id}`);
    }
}
